import { filter } from 'rxjs/operators';
import { untilComponentDestroyed, OnDestroyMixin } from '@w11k/ngx-componentdestroyed';
import { AuthService } from './shared/auth/auth.service';
import { UserService } from './user.service';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { providers, Signer, utils, Contract } from 'ethers';
import { abi } from './abi';
import { UserDataForMetaMaskLoginDto } from './api/userDataForMetaMaskLoginDto';
import { ConfigDto, Currency } from './api';
import { BuyResponseDto } from './api/buyResponseDto';
import { GlobalService } from './global.service';
import { NGXLogger } from 'ngx-logger';
import { PaymentService } from './payment.service';
import { Chain, ChainId, MetaMask, Token } from './metamask';
import { LoginMetaMaskDto } from './api/loginMetaMaskDto';
import { Toastr } from './shared/toastr';
import { MatDialog } from '@angular/material/dialog';
import { MetaMaskPopupComponent } from './shared/meta-mask-popup/meta-mask-popup.component';
import { PaymentTransactionDto } from './api/paymentTransactionDto'
declare var window: any;

const errorStr = 'Error:';
//let FALLBACK_ERROR_MSG = 'error.fallback';

@Injectable({
	providedIn: 'root'
})
export class Web3Service extends OnDestroyMixin {
	web3: providers.Web3Provider;
	metaMask: MetaMask
	config: ConfigDto;
	storedWallet: string;
	signer: Signer;
	_glitter: Contract

	constructor(
		private toastr: Toastr,
		private translateService: TranslateService,
		private globalService: GlobalService,
		private userService: UserService,
		private authService: AuthService,
		private paymentService: PaymentService,
		private log: NGXLogger,
		private dialog: MatDialog
	) {
		super();
		this.globalService.config.subscribe(config => (this.config = config));
		this.authService.isLoggedInAsObservable().pipe(
			filter(isLoggedIn => !!isLoggedIn === true),
			untilComponentDestroyed(this)
		).subscribe(() => {
				this.userService.getProfile().subscribe(profile => (this.storedWallet = profile.wallet));
			});
			//this.translateService.get('error.fallback').subscribe(fallbackStr => FALLBACK_ERROR_MSG = fallbackStr);
	}

	async init (): Promise<Signer> {
		if (!this.web3) {
			if (!window.ethereum) {
				// new MetaMaskOnboarding().startOnboarding()
				//this.toastr.rawError("<span id='toastr-msg' class='toastrmsg-class'>Please install or enable <a href='https://metamask.io/' target='instllMetamask'>MetaMask</a>!</span>", { enableHtml: true })
				//this.log.debug('web3init', t)
				//	.onTap.subscribe( () => {	new MetaMaskOnboarding().startOnboarding()	}	)
				//.onAction.subscribe(a => console.log(a))
				this._openMetMaskInstallDialog()
				return Promise.reject('metamask.install');
			}
			this.metaMask = MetaMask.getMetaMask();
			this.web3 = new providers.Web3Provider(window.ethereum);

		}
		/*this.web3.eth.defaultAccount = this.web3.eth.accounts[0];

		if (!this.web3.eth.coinbase) {
			this.showErrorToastr('metamask.activate');
			return;
		}
		*/
		// Get accounts -> "Connect to site MetaMask " popup opens
		const accounts = await this.metaMask.requestAccounts();
		if (accounts.length < 1) {
			return this.showErrorToastr('metamask.noaccount.selected');
		} else if (accounts.length > 1) {
			return this.showErrorToastr('metamask.multiple.accounts.selected');
		}
		this.log.debug(accounts)

		this.signer = this.web3.getSigner();

		const network = await this.web3.getNetwork()
		if (network.chainId !== this.config.networkId) {
			const chainId = '0x' + this.config.networkId.toString(16) as ChainId;
			this.log.debug('chainId', chainId)
			//this.metaMask.switchToChain(chainId)
			
			this.metaMask.addNswitchChain(chainId)
				.then(() => { // Add asset
					this.metaMask.watchAsset(new Token('GLI', 6, this.config.glitterContractAddress))
						.catch(err => this.log.error('Web3Service:watchAsset', err))
				})
				.catch(err => this.log.error('Web3Service:addNswitchChain:', err))
			this.log.error(network);
			return this.showErrorToastr('metamask.wrongNetwork');
		}
		const address = await this.signer.getAddress();
		if (this.authService.isLoggedIn() &&
			address.toLowerCase() !== this.storedWallet.toLowerCase()) {
				this.log.error(address, this.storedWallet);
				return this.showErrorToastr('metamask.notMatchingWallet', {address: this.storedWallet});
		}
		return this.signer;
	}

	getAddress(): Promise<string> {
		return this.init()
			.then(signer => signer.getAddress());
	}
	/*
		sendTransaction = (response: BuyResponseDto) => {
		 return new Promise((resolve, reject) => {
			//if (!this.web3) {
				reject('no web3');
			}

			const { etherToAddress: to, price, paymentId } = response;
			this.web3.eth.sendTransaction({ to, value: this.web3.toWei(price, 'ether') }, (err, transactionHash: string) => {
				if (err) {
				 reject({ err, paymentId: response.paymentId });
				}
				resolve({ paymentId, transactionHash });
			});
		 });
	}*/

	signMessage = (nonceResp: UserDataForMetaMaskLoginDto): Promise<LoginMetaMaskDto> => {
		return this.init().then(() => {
			return this.signer.signMessage(`I am signing my one-time nonce: ${nonceResp.nonce}`)
				.then ( signature => new LoginMetaMaskDto (nonceResp.address, signature) )
		});
	}
/*
	connectContract = (response: BuyResponseDto) => {
		return new Promise((resolve, reject) => {
			if (!this.web3) {
				reject('no web3');
			}
			const contract = this.web3.eth.contract(abi);
			const contractInstance = contract.at(this.config.glitterContractAddress);
			resolve({ contractInstance, response });
		});
	};

	performTx = (trResponse, paymentId) => {
		trResponse.wait()
		.then(trReceipt => new SendResult( paymentId, trReceipt.transactionHash ))
		.catch(err => {
			return Promise.reject({err, paymentId})
		})
	}
*/
	get glitter() {
		if (!this._glitter) {
			this._glitter = new Contract(this.config.glitterContractAddress, abi, this.signer)
		}
		return this._glitter
	}

	/** Do the transfer in response then send the new transaction has back to BE view paymentSrevice
	 * On error
	 *  - send delete payment request to the BE
	 *  - Display the error via toaster
	 */
	send = (response: BuyResponseDto): Promise<SendResult> => {
		const { etherToAddress: to, paymentId } = response;

		//this.signer.unlock()
		return this.init().then( () => {
			const trRespPromise = response.currency === Currency.GLI ?
				this.glitter.transfer(to, response.price * 1000000 )
				: this.signer.sendTransaction({ to, value: utils.parseEther(response.price + '') })

			return trRespPromise.then(trResponse => trResponse.wait())
				.then(trReceipt => this.paymentService.sendTransactionHash(new SendResult( paymentId, trReceipt.transactionHash )))
				.catch(err => {
					this.paymentService.deletePayment(paymentId).catch(this.handleError);
					this.handleError(err)
				})
		})
	}

/*
	transferGlitter = ({ contractInstance, response }) => {
		return new Promise((resolve, reject) => {
			const { etherToAddress: to, price: value, paymentId } = response;
			contractInstance.transfer(to, value * 1000, (err, transactionHash: string) => {
				if (err) {
					reject({ err, paymentId: response.paymentId });
				}
				resolve({ paymentId, transactionHash });
			});
		});

	};
*/
	getBalance(): Promise<number> {
		return this.init()
			.then(signer => signer.getBalance())
			.then(b => { this.log.debug('ETH balance:', utils.formatEther(b))
				return Number.parseFloat(utils.formatEther(b))}) // FIXME ugly solution
			.catch(this.handleError)
	}

	errorMsg2TransKey(msg: string): string {
		return msg.trim()
			.replace(/[^a-zA-Z0-9\s]/g, '')
			.replace(/\s/g, '.')
			.toLowerCase()
	}

	handleError = err => {
		if (err && err.message) {
			let transKey = err.message
			if (err.message.startsWith('MetaMask')) {
				transKey = 'error.metamask.' + this.errorMsg2TransKey(err.message)
			} else {
				const lastIndexOfErrorStr = err.message.lastIndexOf(errorStr);
				transKey = this.errorMsg2TransKey(err.message.slice(lastIndexOfErrorStr + errorStr.length))
			}
			this.log.debug('web3.handleErr', err, transKey)
			this.translateService.get(transKey).subscribe(translatedStr => {
				if (transKey === 'error.metamask.metamask.tx.signature.user.denied.transaction.signature') {
					this.toastr.rawInfo(translatedStr);
				} else if (translatedStr !== transKey) {
					this.toastr.rawError(translatedStr);
				} else {
					this.toastr.error('error.fallback');
				}
			});
		}
		return Promise.reject(err)
	};

	private showErrorToastr (translateKey: string, params?: Object, enableHtml = false): Promise<Signer> {
/*		this.translateService.get(translateKey).subscribe(translatedText => {
			this.toastr.error(translatedText, '', { enableHtml });
		});*/
		this.toastr.error(translateKey, params, { enableHtml });
		return Promise.reject(translateKey);
	};

	private _openMetMaskInstallDialog(): void {
		const dialogRef = this.dialog.open(MetaMaskPopupComponent)
		// "metamask.install": "Please <a id='installMetaMaskLink' href='#' onClick='installMetaMask()'>install</a> or enable <a href='https://metamask.io/'>MetaMask</a>!",
	}
}

export class SendResult implements PaymentTransactionDto{
	constructor(
		public paymentId: string,
		public transactionHash: string) {}
}